import { render, staticRenderFns } from "./RELComunicacao.vue?vue&type=template&id=73389f75&"
import script from "./RELComunicacao.vue?vue&type=script&lang=js&"
export * from "./RELComunicacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports